import { AxiosRequestConfig } from 'axios';
import type { AxiosDataReturn } from '../types/generic';
import type { TPaystackSubscriptionPaginated } from '../types/payment';
import api from './api-instance';
import { toast } from 'react-toastify';

export const subscriptionsList = async (args?: AxiosRequestConfig<any>) => {
  try {
    const res = await api.get<AxiosDataReturn<TPaystackSubscriptionPaginated>>(
      '/payment/admin/subscriptions',
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};
